import React from "react";
import SpecialistProfileWizard from "./SpecialistProfileWizard";

const SpecialistProfileCreatePage: React.FC = () => {
  // This page is the entry point for creating a new specialist profile.
  // The wizard handles all tabs, state, validation, and submission.
  return <SpecialistProfileWizard mode="create" />;
};

export default SpecialistProfileCreatePage;
